import React from 'react';
import { 
    Home,
    BarChart2,
    DollarSign,
    FileText,
    Settings,
    Users,
    PlusCircle,
    Calendar,
    LogOut
} from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Verificar se a rota atual corresponde ao item do menu
  const isActive = (path) => {
    if (path === '/dashboard' && location.pathname === '/dashboard') {
      return true;
    }
    if (path !== '/dashboard' && location.pathname.includes(path)) {
      return true;
    }
    // Caso especial para a maquete virtual que está na seção de vendas
    if (path === '/sales' && location.pathname === '/virtual-model') {
      return true;
    }
    return false;
  };
  
  return (
    <div className="w-64 bg-white border-r border-gray-200 h-full flex flex-col">
      {/* Logo */}
      <div className="px-6 py-4 border-b border-gray-200">
        <div 
          className="bg-blue-900 text-white py-2 px-4 rounded text-lg font-bold cursor-pointer"
          onClick={() => navigate('/dashboard')}
        >
          SURFLAND BRASIL
        </div>
      </div>
      
      {/* Navigation */}
      <div className="py-4 flex-1 overflow-y-auto">
        <div className="px-4 mb-2 text-xs font-semibold text-gray-500">VENDAS</div>
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/sales/flow') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/sales/flow')}
        >
          <PlusCircle size={18} className="mr-2" />
          <span>Nova Venda</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/sales/proposals') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/sales/proposals')}
        >
          <FileText size={18} className="mr-2" />
          <span>Propostas</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/sales/contracts') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/sales/contracts')}
        >
          <FileText size={18} className="mr-2" />
          <span>Contratos</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/customers') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/customers')}
        >
          <Users size={18} className="mr-2" />
          <span>Clientes</span>
        </button>
        
        <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-500">ESTOQUE</div>
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/inventory') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/inventory')}
        >
          <Home size={18} className="mr-2" />
          <span>Disponibilidade</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 ${location.pathname === '/virtual-model' ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/virtual-model')}
        >
          <Home size={18} className="mr-2" />
          <span>Maquete Virtual</span>
        </button>
        
        <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-500">FINANCEIRO</div>
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/financial/payments') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/financial/payments')}
        >
          <DollarSign size={18} className="mr-2" />
          <span>Pagamentos</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/financial/commissions') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/financial/commissions')}
        >
          <DollarSign size={18} className="mr-2" />
          <span>Comissões</span>
        </button>
        
        <div className="px-4 mt-6 mb-2 text-xs font-semibold text-gray-500">CONFIGURAÇÕES</div>
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/campaigns') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/backoffice/campaigns')}
        >
          <Settings size={18} className="mr-2" />
          <span>Campanhas</span>
        </button>
        
        <button
          className={`w-full flex items-center px-4 py-3 ${isActive('/backoffice') && !isActive('/campaigns') ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`}
          onClick={() => navigate('/backoffice')}
        >
          <Settings size={18} className="mr-2" />
          <span>Backoffice</span>
        </button>
        
        <button
          className="w-full flex items-center px-4 py-3 text-gray-700 hover:bg-gray-100"
          onClick={logout}
        >
          <LogOut size={18} className="mr-2" />
          <span>Sair</span>
        </button>
      </div>
      
      {/* Status Badge */}
      <div className="border-t border-gray-200 p-4">
        <div className="flex items-center p-3 bg-blue-50 text-blue-900 rounded-md">
          <div className="mr-3 flex-shrink-0">
            <div className="h-3 w-3 rounded-full bg-green-500"></div>
          </div>
          <div>
            <p className="text-sm font-medium">Status do Sistema</p>
            <p className="text-xs text-gray-500">Conectado ao Sienge</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 